import * as React from 'react';
import styled, { css } from 'styled-components';
import { Layout as AntLayout } from 'antd';
import { VarnishContext } from './VarnishContext';
export const Layout = styled(AntLayout) `
    // as any here is fixing a bug: Exported variable 'Layout' has or is using name 'LayoutType'
    // from external module ".../node_modules/antd/es/layout/index" but cannot be named.
    && {
        // if the user passes a key to the color theme, use the mapped color,
        // else treat the string as a normal color string
        background: ${({ theme, bgcolor }) => bgcolor ? (theme.color[bgcolor] ? theme.color[bgcolor] : bgcolor) : 'none'};
    }
`;
export const Content = ({ children, main, className, ...basicProps }) => (React.createElement(VarnishContext.Consumer, null, ({ layout }) => main ? (React.createElement(MainContent, { layout: layout, className: className, ...basicProps }, children)) : (React.createElement(NotMainContent, { layout: layout, className: className, ...basicProps }, children))));
const contentCSS = css `
    max-width: ${({ theme, layout }) => layout === 'center-aligned' ? theme.breakpoints.xl.toString() : null};
    width: 100%;
    ${({ layout }) => (layout === 'center-aligned' ? 'margin: 0 auto;' : '')}
    padding: ${({ theme }) => theme.spacing.lg.toString()};

    @media (max-width: ${({ theme }) => theme.breakpoints.sm.toString()}) {
        padding: ${({ theme }) => theme.spacing.sm.toString()};
    }
`;
const MainContent = styled(AntLayout.Content) `
    ${contentCSS}
`;
const NotMainContent = styled.div `
    ${contentCSS}
`;
export const LeftSider = (props) => (React.createElement(VarnishContext.Consumer, null, ({ currentHeaderHeight }) => (React.createElement(StyledLeftSider, { trigger: null, breakpoint: "md", ...props },
    React.createElement(FixedContainer, { paddingTop: currentHeaderHeight, breakpoint: props.breakpoint || 'md', width: props.width, collapsedWidth: props.collapsedWidth }, props.children)))));
const StyledLeftSider = styled(AntLayout.Sider) `
    background: ${({ theme }) => theme.color.white.toString()};
    transition: none;
`;
const FixedContainer = styled.div `
    border-right: 1px solid ${({ theme }) => theme.palette.border.default.toString()};
    position: fixed;
    top: 0;
    bottom: 0;
    width: ${({ width }) => width};
    padding-top: ${({ paddingTop }) => paddingTop}px;
    transition: padding-top 200ms ease-in-out;
    overflow: auto;

    @media screen and (max-width: ${({ theme, breakpoint }) => theme.breakpoints[breakpoint].toString()}) {
        width: ${({ collapsedWidth }) => collapsedWidth};
    }
`;
//# sourceMappingURL=Layout.js.map